// extracted by mini-css-extract-plugin
export var buttonIconWrapper = "_81-4";
export var collapsed = "_81-1";
export var headerBar = "_81-0";
export var leftHeaderContent = "_81-3";
export var subjectContainer = "_81-2";